import { KeySequence } from "~/components/ui/kbd"
import { Card } from "~/components/ui/card"

export function ShortcutCard({
	title,
	description,
	keys,
	sequence
}: {
	title: string
	description: string
	keys: string
	sequence?: boolean
}) {
	return (
		<Card density="tight" className="min-h-24 justify-between">
			<div className="min-w-0">
				<div className="truncate text-sm font-medium text-text-main">
					{title}
				</div>
				<div className="mt-1 line-clamp-2 text-xs text-text-sub">
					{description}
				</div>
			</div>
			<KeySequence keys={keys} sequence={sequence} />
		</Card>
	)
}
